import { Component } from '@angular/core';

@Component({
  selector: 'app-info-privacy-policy',
  standalone: false,
  templateUrl: './info-privacy-policy.component.html',
  styleUrl: './info-privacy-policy.component.scss'
})
export class InfoPrivacyPolicyComponent {

}
